module.exports = __webpack_public_path__ + "img/answer_report_first_run.d1c60213.svg";